import { createElement } from "react";
import React from "react";
import { ContextMsg, useCtx } from "./Context.jsx";
import { createObj, equals } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Button, MessageBarActions, MessageBarBody, Text as Text$, MessageBar } from "@fluentui/react-components";
import { Role__ToDescription } from "./Shared/SharedModels.jsx";
import { ofArray, singleton } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ArrowResetRegular } from "@fluentui/react-icons";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, User } from "./ApiClient.jsx";
import { errorToast } from "./Toasts.jsx";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";

/**
 * Sticky high-contrast banner shown at the top of the app whenever the user is viewing as a
 * role other than their real one. Surfaces the active role and a one-click reset so admins
 * (or teachers) can't get "stuck" in a lower view-as mode without realising it.
 */
export function RoleBanner() {
    let elems, props_2, el, name, el_6, el_4, el_2;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    if (equals(ctx.User.Role, ctx.User.RealRole)) {
        return defaultOf();
    }
    else {
        const el_8 = MessageBar;
        return createElement(el_8, createObj(ofArray([["intent", "warning"], ["shape", "square"], (elems = [(props_2 = singleton((el = Text$, createElement(el, {
            children: (`Du ser appen som ${Role__ToDescription(ctx.User.Role)}. `) + "Endringer du gjør gjelder som denne rollen.",
        }))), (name = MessageBarBody, createElement(name, {
            children: reactApi.Children.toArray(Array.from(props_2)),
        }))), (el_6 = MessageBarActions, createElement(el_6, {
            containerAction: (el_4 = Button, createElement(el_4, {
                size: "small",
                appearance: "transparent",
                icon: (el_2 = ArrowResetRegular, createElement(el_2, {})),
                children: `Tilbake til ${Role__ToDescription(ctx.User.RealRole)}`,
                onClick: (_arg) => {
                    let pr_1;
                    const pr = startAsPromise(User.SetActiveRole(undefined));
                    pr_1 = (pr.then((res) => {
                        let matchResult;
                        if (res.tag === 1) {
                            if (res.fields[0].tag === 1) {
                                matchResult = 1;
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 0;
                        }
                        switch (matchResult) {
                            case 0: {
                                setCtx(new ContextMsg(2, [res.fields[0]]));
                                break;
                            }
                            case 1: {
                                errorToast(setCtx, "resetActiveRoleError", "Kunne ikke tilbakestille rolle", "", undefined);
                                break;
                            }
                        }
                    }));
                    void (pr_1.catch((ex) => {
                        toastServerError(setCtx, ex);
                    }));
                },
            })),
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
}

//# sourceMappingURL=RoleBanner.jsx.map
